import { IApiEpBillingProduct } from "@smp/api";

import { CompositionFeatureSubscription } from "./composition_feature_subscription";
import { CompositionPlanProduct } from "./composition_plan_product";
import { CompositionPostsPackage } from "./composition_posts_package";
import { CompositionTokenPackage } from "./composition_token_package";

export const Composition = ({ product }: { product: IApiEpBillingProduct }) => {
  const isFeatureSubscription = product.type === "feature-subscription";
  const isPlanProduct = product.type === "plan-product";
  const isToken = product.type === "token";

  if (isFeatureSubscription) {
    return (
      <CompositionFeatureSubscription productFeatureSubscription={product} />
    );
  }

  if (isPlanProduct) {
    return <CompositionPlanProduct productPlanProduct={product} />;
  }

  if (isToken) {
    return <CompositionTokenPackage productTokenPackage={product} />;
  }

  return <CompositionPostsPackage productPostsPackage={product} />;
};
